import { ApplicationFilterOptions } from "@domain/application/application";
import { CountryCode } from "@domain/currentProfile/countryCode";
import { ContentLicense } from "@domain/licence/contentLicense";
import { Category } from "@domain/lms/category/category";
import { ContentLanguage } from "@domain/lms/contentLanguage";
import { ContentLevel } from "@domain/lms/contentLevel";
import { CourseDuration, CourseProvider } from "@domain/lms/course/course";
import { OrganizationSubType, OrganizationType } from "@domain/organization/organizationType";
import { Scoring } from "@domain/ranking/ranking";
import { TransactionFilterOptions } from "@domain/wallet/wallet";
import { PaginationOptions } from "@utils/page";

export function pageParams(pageOptions: PaginationOptions): string {
	const { page, size, sort } = pageOptions;
	const pageParam = `page=${page}`;
	const sizeParam = size !== undefined ? `size=${size}` : "";
	const sortParam = sort !== undefined ? `sort=${sort}` : "";
	return [pageParam, sizeParam, sortParam].filter((p) => !!p).join("&");
}

export function filterParams(
	categories?: Category[],
	levels?: ContentLevel[],
	languages?: ContentLanguage[],
	durations?: CourseDuration[],
	providers?: CourseProvider[],
	orgTypes?: OrganizationType[],
	orgSubTypes?: OrganizationSubType[],
	countries?: CountryCode[],
	license?: ContentLicense[],
	scoring?: Scoring[],
	rating?: number
): string {
	const categoriesParam = categories !== undefined ? `categories=${categories.join(",")}` : "";
	const levelsParam = levels !== undefined ? `levels=${levels.join(",")}` : "";
	const languagesParam = languages !== undefined ? `languages=${languages.join(",")}` : "";
	const durationsParam = durations !== undefined ? `durations=${durations.join(",")}` : "";
	const providersParam = providers !== undefined ? `providers=${providers.join(",")}` : "";
	const orgTypesParam = orgTypes !== undefined && orgTypes.length === 1 ? `type=${orgTypes[0]}` : "";
	const orgSubTypesParam = orgSubTypes !== undefined ? `subTypes=${orgSubTypes.join(",")}` : "";
	const countriesParam = countries !== undefined ? `countries=${countries.join(",")}` : "";
	const licenseParam = license !== undefined ? `license=${license}` : "";
	const scoringParam = scoring !== undefined ? `meanFeedbackScore=${scoring}` : "";
	const ratingParam = rating !== undefined ? `averageFeedback=${rating}` : "";
	return [
		categoriesParam,
		levelsParam,
		languagesParam,
		durationsParam,
		providersParam,
		orgTypesParam,
		orgSubTypesParam,
		countriesParam,
		licenseParam,
		scoringParam,
		ratingParam,
	]
		.filter((p) => !!p)
		.join("&");
}

export function applicationFilterParams(filterOptions?: ApplicationFilterOptions): string {
	if (!filterOptions) return "";
	const { countryResidence, levelName, status } = filterOptions;
	const countryResidenceParam = countryResidence !== undefined ? `countryResidence=${countryResidence}` : "";
	const levelNameParam = levelName !== undefined ? `levelName=${levelName}` : "";
	const statusParam = status !== undefined ? `status=${status}` : "";

	return `&${[countryResidenceParam, levelNameParam, statusParam].filter((p) => !!p).join("&")}`;
}

export function transactionFilterParams(filterOptions?: TransactionFilterOptions): string {
	if (!filterOptions) return "";
	const { period } = filterOptions;
	const periodParam = period !== undefined ? `period=${period}` : "";

	return `&${[periodParam].filter((p) => !!p).join("&")}`;
}
